/**
 * AdminNavigation Component Styles
 * Carbon Design System compliant styles with WCAG 2.5.5 (AA) touch target compliance
 */
.adminNavigation {
  background-color: var(--cds-background);
  border-right: 1px solid var(--cds-border-subtle);
  height: 100vh;
  transition: all var(--cds-productive-02) cubic-bezier(0.2, 0, 0.38, 0.9);
  /* Accessibility: Respect user's motion preferences */
}
@media (prefers-reduced-motion: reduce) {
  .adminNavigation {
    transition: none;
  }
}
.adminNavigation {
  /* WCAG 2.5.5 (AA) Touch Target Compliance - Ensure all interactive elements are at least 44x44px */
  /* Apply to all SideNav links and menu items */
}
.adminNavigation :global {
  /* SideNav Links - Increase minimum height and padding for 44px touch targets */
}
.adminNavigation :global .cds--side-nav__link,
.adminNavigation :global .cds--side-nav__menu-item {
  min-height: 48px !important;
  padding: var(--cds-spacing-04) var(--cds-spacing-05) !important;
  display: flex !important;
  align-items: center !important;
}
.adminNavigation :global {
  /* SideNav Link Button - Ensure proper touch target */
}
.adminNavigation :global .cds--side-nav__link-text {
  padding: var(--cds-spacing-03) 0 !important;
}
.adminNavigation :global {
  /* SideNav Menu - Ensure clickable area meets 44px */
}
.adminNavigation :global .cds--side-nav__submenu {
  min-height: 48px !important;
}
.adminNavigation :global {
  /* SideNav Menu Button */
}
.adminNavigation :global .cds--side-nav__submenu-title {
  min-height: 48px !important;
  padding: var(--cds-spacing-04) var(--cds-spacing-05) !important;
  display: flex !important;
  align-items: center !important;
}
.adminNavigation :global {
  /* SideNav Icon - Ensure icon container has adequate size */
}
.adminNavigation :global .cds--side-nav__icon {
  min-width: 48px !important;
  min-height: 48px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}
.adminNavigation :global {
  /* SideNav Menu Button - Increase touch target */
}
.adminNavigation :global .cds--side-nav__submenu-chevron {
  min-width: 48px !important;
  min-height: 48px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}
.adminNavigation :global {
  /* Mobile responsive - Hide SideNav on small screens, use overlay */
}
@media (max-width: 768px) {
  .adminNavigation :global .cds--side-nav {
    position: fixed !important;
    z-index: 6000 !important;
  }
  .adminNavigation :global .cds--side-nav--expanded {
    width: 100% !important;
    max-width: 320px !important;
  }
}
.adminNavigation :global {
  /* Prevent horizontal scroll on mobile */
}
@media (max-width: 420px) {
  .adminNavigation :global .cds--side-nav {
    max-width: 280px !important;
  }
}

.navItem {
  color: var(--cds-text-primary);
  background-color: transparent;
  min-height: 44px; /* WCAG 2.5.5 compliance */
}
.navItem--active {
  color: var(--cds-interactive-01);
  background-color: var(--cds-background-selected);
}
@media (prefers-reduced-motion: reduce) {
  .navItem {
    transition: none;
  }
}

.contentArea {
  margin-left: 16rem;
  transition: margin-left var(--cds-productive-02) cubic-bezier(0.2, 0, 0.38, 0.9);
  background-color: var(--cds-background);
  width: 100%;
  overflow: auto;
}
.contentArea--collapsed {
  margin-left: 0;
}
@media (prefers-reduced-motion: reduce) {
  .contentArea {
    transition: none;
  }
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiL2hvbWUvc2t5Z2dlL3NpZ21hMDgvZnJvbnRlbmQvc3JjL2NvbXBvbmVudHMvYWRtaW4iLCJzb3VyY2VzIjpbIkFkbWluTmF2aWdhdGlvbi5tb2R1bGUuc2NzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtBQUFBO0FBQUE7QUFBQTtBQUtBO0VBQ0U7RUFDQTtFQUNBO0VBQ0E7QUFFQTs7QUFDQTtFQVBGO0lBUUk7OztBQVJKO0FBV0U7QUFDQTs7QUFDQTtBQUNFOztBQUNBO0FBQUE7RUFFRTtFQUNBO0VBQ0E7RUFDQTs7QUFQSjtBQVVFOztBQUNBO0VBQ0U7O0FBWko7QUFlRTs7QUFDQTtFQUNFOztBQWpCSjtBQW9CRTs7QUFDQTtFQUNFO0VBQ0E7RUFDQTtFQUNBOztBQXpCSjtBQTRCRTs7QUFDQTtFQUNFO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7O0FBbENKO0FBcUNFOztBQUNBO0VBQ0U7RUFDQTtFQUNBO0VBQ0E7RUFDQTs7QUEzQ0o7QUE4Q0U7O0FBQ0E7RUFDRTtJQUNFO0lBQ0E7O0VBR0Y7SUFDRTtJQUNBOzs7QUF2RE47QUEyREU7O0FBQ0E7RUFDRTtJQUNFOzs7O0FBTVI7RUFDRTtFQUNBO0VBQ0E7O0FBRUE7RUFDRTtFQUNBOztBQUdGO0VBVkY7SUFXSTs7OztBQUlKO0VBQ0U7RUFDQTtFQUNBO0VBQ0E7RUFDQTs7QUFFQTtFQUNFOztBQUdGO0VBWEY7SUFZSSIsInNvdXJjZXNDb250ZW50IjpbIi8qKlxuICogQWRtaW5OYXZpZ2F0aW9uIENvbXBvbmVudCBTdHlsZXNcbiAqIENhcmJvbiBEZXNpZ24gU3lzdGVtIGNvbXBsaWFudCBzdHlsZXMgd2l0aCBXQ0FHIDIuNS41IChBQSkgdG91Y2ggdGFyZ2V0IGNvbXBsaWFuY2VcbiAqL1xuXG4uYWRtaW5OYXZpZ2F0aW9uIHtcbiAgYmFja2dyb3VuZC1jb2xvcjogdmFyKC0tY2RzLWJhY2tncm91bmQpO1xuICBib3JkZXItcmlnaHQ6IDFweCBzb2xpZCB2YXIoLS1jZHMtYm9yZGVyLXN1YnRsZSk7XG4gIGhlaWdodDogMTAwdmg7XG4gIHRyYW5zaXRpb246IGFsbCB2YXIoLS1jZHMtcHJvZHVjdGl2ZS0wMikgY3ViaWMtYmV6aWVyKDAuMiwgMCwgMC4zOCwgMC45KTtcblxuICAvKiBBY2Nlc3NpYmlsaXR5OiBSZXNwZWN0IHVzZXIncyBtb3Rpb24gcHJlZmVyZW5jZXMgKi9cbiAgQG1lZGlhIChwcmVmZXJzLXJlZHVjZWQtbW90aW9uOiByZWR1Y2UpIHtcbiAgICB0cmFuc2l0aW9uOiBub25lO1xuICB9XG5cbiAgLyogV0NBRyAyLjUuNSAoQUEpIFRvdWNoIFRhcmdldCBDb21wbGlhbmNlIC0gRW5zdXJlIGFsbCBpbnRlcmFjdGl2ZSBlbGVtZW50cyBhcmUgYXQgbGVhc3QgNDR4NDRweCAqL1xuICAvKiBBcHBseSB0byBhbGwgU2lkZU5hdiBsaW5rcyBhbmQgbWVudSBpdGVtcyAqL1xuICA6Z2xvYmFsIHtcbiAgICAvKiBTaWRlTmF2IExpbmtzIC0gSW5jcmVhc2UgbWluaW11bSBoZWlnaHQgYW5kIHBhZGRpbmcgZm9yIDQ0cHggdG91Y2ggdGFyZ2V0cyAqL1xuICAgIC5jZHMtLXNpZGUtbmF2X19saW5rLFxuICAgIC5jZHMtLXNpZGUtbmF2X19tZW51LWl0ZW0ge1xuICAgICAgbWluLWhlaWdodDogNDhweCAhaW1wb3J0YW50O1xuICAgICAgcGFkZGluZzogdmFyKC0tY2RzLXNwYWNpbmctMDQpIHZhcigtLWNkcy1zcGFjaW5nLTA1KSAhaW1wb3J0YW50O1xuICAgICAgZGlzcGxheTogZmxleCAhaW1wb3J0YW50O1xuICAgICAgYWxpZ24taXRlbXM6IGNlbnRlciAhaW1wb3J0YW50O1xuICAgIH1cblxuICAgIC8qIFNpZGVOYXYgTGluayBCdXR0b24gLSBFbnN1cmUgcHJvcGVyIHRvdWNoIHRhcmdldCAqL1xuICAgIC5jZHMtLXNpZGUtbmF2X19saW5rLXRleHQge1xuICAgICAgcGFkZGluZzogdmFyKC0tY2RzLXNwYWNpbmctMDMpIDAgIWltcG9ydGFudDtcbiAgICB9XG5cbiAgICAvKiBTaWRlTmF2IE1lbnUgLSBFbnN1cmUgY2xpY2thYmxlIGFyZWEgbWVldHMgNDRweCAqL1xuICAgIC5jZHMtLXNpZGUtbmF2X19zdWJtZW51IHtcbiAgICAgIG1pbi1oZWlnaHQ6IDQ4cHggIWltcG9ydGFudDtcbiAgICB9XG5cbiAgICAvKiBTaWRlTmF2IE1lbnUgQnV0dG9uICovXG4gICAgLmNkcy0tc2lkZS1uYXZfX3N1Ym1lbnUtdGl0bGUge1xuICAgICAgbWluLWhlaWdodDogNDhweCAhaW1wb3J0YW50O1xuICAgICAgcGFkZGluZzogdmFyKC0tY2RzLXNwYWNpbmctMDQpIHZhcigtLWNkcy1zcGFjaW5nLTA1KSAhaW1wb3J0YW50O1xuICAgICAgZGlzcGxheTogZmxleCAhaW1wb3J0YW50O1xuICAgICAgYWxpZ24taXRlbXM6IGNlbnRlciAhaW1wb3J0YW50O1xuICAgIH1cblxuICAgIC8qIFNpZGVOYXYgSWNvbiAtIEVuc3VyZSBpY29uIGNvbnRhaW5lciBoYXMgYWRlcXVhdGUgc2l6ZSAqL1xuICAgIC5jZHMtLXNpZGUtbmF2X19pY29uIHtcbiAgICAgIG1pbi13aWR0aDogNDhweCAhaW1wb3J0YW50O1xuICAgICAgbWluLWhlaWdodDogNDhweCAhaW1wb3J0YW50O1xuICAgICAgZGlzcGxheTogZmxleCAhaW1wb3J0YW50O1xuICAgICAgYWxpZ24taXRlbXM6IGNlbnRlciAhaW1wb3J0YW50O1xuICAgICAganVzdGlmeS1jb250ZW50OiBjZW50ZXIgIWltcG9ydGFudDtcbiAgICB9XG5cbiAgICAvKiBTaWRlTmF2IE1lbnUgQnV0dG9uIC0gSW5jcmVhc2UgdG91Y2ggdGFyZ2V0ICovXG4gICAgLmNkcy0tc2lkZS1uYXZfX3N1Ym1lbnUtY2hldnJvbiB7XG4gICAgICBtaW4td2lkdGg6IDQ4cHggIWltcG9ydGFudDtcbiAgICAgIG1pbi1oZWlnaHQ6IDQ4cHggIWltcG9ydGFudDtcbiAgICAgIGRpc3BsYXk6IGZsZXggIWltcG9ydGFudDtcbiAgICAgIGFsaWduLWl0ZW1zOiBjZW50ZXIgIWltcG9ydGFudDtcbiAgICAgIGp1c3RpZnktY29udGVudDogY2VudGVyICFpbXBvcnRhbnQ7XG4gICAgfVxuXG4gICAgLyogTW9iaWxlIHJlc3BvbnNpdmUgLSBIaWRlIFNpZGVOYXYgb24gc21hbGwgc2NyZWVucywgdXNlIG92ZXJsYXkgKi9cbiAgICBAbWVkaWEgKG1heC13aWR0aDogNzY4cHgpIHtcbiAgICAgIC5jZHMtLXNpZGUtbmF2IHtcbiAgICAgICAgcG9zaXRpb246IGZpeGVkICFpbXBvcnRhbnQ7XG4gICAgICAgIHotaW5kZXg6IDYwMDAgIWltcG9ydGFudDtcbiAgICAgIH1cblxuICAgICAgLmNkcy0tc2lkZS1uYXYtLWV4cGFuZGVkIHtcbiAgICAgICAgd2lkdGg6IDEwMCUgIWltcG9ydGFudDtcbiAgICAgICAgbWF4LXdpZHRoOiAzMjBweCAhaW1wb3J0YW50O1xuICAgICAgfVxuICAgIH1cblxuICAgIC8qIFByZXZlbnQgaG9yaXpvbnRhbCBzY3JvbGwgb24gbW9iaWxlICovXG4gICAgQG1lZGlhIChtYXgtd2lkdGg6IDQyMHB4KSB7XG4gICAgICAuY2RzLS1zaWRlLW5hdiB7XG4gICAgICAgIG1heC13aWR0aDogMjgwcHggIWltcG9ydGFudDtcbiAgICAgIH1cbiAgICB9XG4gIH1cbn1cblxuLm5hdkl0ZW0ge1xuICBjb2xvcjogdmFyKC0tY2RzLXRleHQtcHJpbWFyeSk7XG4gIGJhY2tncm91bmQtY29sb3I6IHRyYW5zcGFyZW50O1xuICBtaW4taGVpZ2h0OiA0NHB4OyAvKiBXQ0FHIDIuNS41IGNvbXBsaWFuY2UgKi9cblxuICAmLS1hY3RpdmUge1xuICAgIGNvbG9yOiB2YXIoLS1jZHMtaW50ZXJhY3RpdmUtMDEpO1xuICAgIGJhY2tncm91bmQtY29sb3I6IHZhcigtLWNkcy1iYWNrZ3JvdW5kLXNlbGVjdGVkKTtcbiAgfVxuXG4gIEBtZWRpYSAocHJlZmVycy1yZWR1Y2VkLW1vdGlvbjogcmVkdWNlKSB7XG4gICAgdHJhbnNpdGlvbjogbm9uZTtcbiAgfVxufVxuXG4uY29udGVudEFyZWEge1xuICBtYXJnaW4tbGVmdDogMTZyZW07XG4gIHRyYW5zaXRpb246IG1hcmdpbi1sZWZ0IHZhcigtLWNkcy1wcm9kdWN0aXZlLTAyKSBjdWJpYy1iZXppZXIoMC4yLCAwLCAwLjM4LCAwLjkpO1xuICBiYWNrZ3JvdW5kLWNvbG9yOiB2YXIoLS1jZHMtYmFja2dyb3VuZCk7XG4gIHdpZHRoOiAxMDAlO1xuICBvdmVyZmxvdzogYXV0bztcblxuICAmLS1jb2xsYXBzZWQge1xuICAgIG1hcmdpbi1sZWZ0OiAwO1xuICB9XG5cbiAgQG1lZGlhIChwcmVmZXJzLXJlZHVjZWQtbW90aW9uOiByZWR1Y2UpIHtcbiAgICB0cmFuc2l0aW9uOiBub25lO1xuICB9XG59XG4iXX0= */